import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { AuthService } from '../_core/auth.service';
import { BrandingService } from '../_core/branding.service';
import {
  FIXED_NETWORKS_OFFICE_URL,
  hasLoggedInOnce,
  PREVIOUS_VIRTUAL_OFFICE_URL,
  PROPERTY_MANAGERS_OFFICE_URL,
} from '../welcome-tour/previous-office-url';
import { ActivatedRoute, Params } from '@angular/router';
import { tap } from 'rxjs';
import { LoginComponent } from './login/login.component';
import { DemoLoginComponent } from './demo-login/demo-login.component';
import { Register } from './register/register';
import { ChangePassword } from './change-password/change-password';
import { RecoveryPassword } from './recovery-password/recovery-password';
import { ImageModule } from 'primeng/image';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrl: './auth.component.scss',
  imports: [
    ChangePassword,
    RecoveryPassword,
    LoginComponent,
    DemoLoginComponent,
    Register,
    ImageModule,
    CommonModule,
  ],
})
export class AuthComponent implements OnInit {
  private $auth = inject(AuthService);
  public readonly $branding = inject(BrandingService);
  protected readonly previousOfficeUrl = PREVIOUS_VIRTUAL_OFFICE_URL;
  protected readonly propertyManagersOfficeUrl = PROPERTY_MANAGERS_OFFICE_URL;
  protected readonly fixedNetworksOfficeUrl = FIXED_NETWORKS_OFFICE_URL;

  private aRoute = inject(ActivatedRoute);

  public readonly view = signal('LOGIN');
  private readonly introDismissed = signal(false);
  private readonly skipWelcome = signal(this.hasSkipWelcome(this.aRoute.snapshot.queryParams));
  protected readonly showNewOfficeIntro = computed(
    () =>
      this.view() === 'LOGIN' &&
      this.$branding.isGGM() &&
      !this.introDismissed() &&
      !this.skipWelcome() &&
      !hasLoggedInOnce(),
  );
  public isLoading: boolean = false;

  public loading: boolean = true;

  protected tryNewVersion(): void {
    this.introDismissed.set(true);
  }

  private hasSkipWelcome(params: Params | null | undefined): boolean {
    return params?.['skip-welcome'] != null;
  }

  ngOnInit(): void {
    // CAMBIAR VISTAS SEGUN DATA-PARAMS (app.routes.ts)
    this.aRoute.data
      .pipe(
        tap((data: Params) => {
          if (!!data['module']) {
            this.view.set(data['module']);
          }
        }),
      )
      .subscribe();

    this.aRoute.queryParams
      .pipe(
        tap((params: Params) => {
          this.skipWelcome.set(this.hasSkipWelcome(params));
          if (params['view'] === 'CHANGE_PASSWORD') {
            this.view.set('CHANGE_PASSWORD');
          }
        }),
      )
      .subscribe();
  }
}
